// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.separator[data-v-3bce4040]\n{\n\tborder-top: 1px solid #747474\n}\n", ""]);
// Exports
module.exports = exports;
